function UpgradePlatform() {
  return (
    <svg width="100%" height="223" viewBox="0 0 375 223" fill="none" preserveAspectRatio="xMidYMax slice" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_1_4137"
        style={{
          maskType: 'luminance',
        }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="376"
        height="223"
      >
        <path d="M375.163 0.0683594H0.0495605V222.778H375.163V0.0683594Z" fill="white" />
      </mask>
      <g mask="url(#mask0_1_4137)">
        <path d="M375.223 44.5231H0.0617428V140.559H375.223V44.5231Z" fill="url(#paint0_linear_1_4137)" />
        <path
          d="M385.629 141.899C385.384 141.899 385.145 141.792 384.983 141.576L313.541 46.3841C313.272 46.0311 313.344 45.5225 313.703 45.2592C314.056 44.9899 314.558 45.0617 314.828 45.4207L386.27 140.613C386.539 140.966 386.467 141.474 386.108 141.738C385.964 141.845 385.797 141.899 385.623 141.899H385.629Z"
          fill="url(#paint1_linear_1_4137)"
        />
        <path
          d="M-10.4759 141.899C-10.6435 141.899 -10.811 141.845 -10.9606 141.737C-11.3137 141.468 -11.3855 140.966 -11.1222 140.612L60.3198 45.4204C60.5891 45.0613 61.0918 44.9955 61.4448 45.2588C61.7979 45.5281 61.8697 46.0307 61.6064 46.3838L-9.83564 141.576C-9.99123 141.785 -10.2366 141.899 -10.4819 141.899H-10.4759Z"
          fill="url(#paint2_linear_1_4137)"
        />
        <path
          d="M-17.513 63.1689C-17.7583 63.1689 -17.9977 63.0612 -18.1532 62.8518C-18.4225 62.4987 -18.3507 61.9961 -17.9977 61.7268L5.32763 44.2897C5.68069 44.0204 6.18333 44.0922 6.45261 44.4453C6.72188 44.7983 6.65008 45.3009 6.29703 45.5702L-17.0223 63.0074C-17.1659 63.1151 -17.3394 63.1689 -17.507 63.1689H-17.513Z"
          fill="url(#paint3_linear_1_4137)"
        />
        <path
          d="M391.284 61.1344C391.117 61.1344 390.949 61.0805 390.806 60.9728L368.857 45.4146C368.503 45.1513 368.426 44.6427 368.695 44.2896C368.958 43.9306 369.467 43.8588 369.82 44.1281L391.769 59.6862C392.122 59.9495 392.2 60.4582 391.931 60.8112C391.775 61.0207 391.53 61.1344 391.284 61.1344Z"
          fill="url(#paint4_linear_1_4137)"
        />
        <path
          d="M115.198 61.4509L85.4014 140.809L86.8967 141.371L116.694 62.0122L115.198 61.4509Z"
          fill="url(#paint5_linear_1_4137)"
        />
        <path
          d="M188.18 56.8785L186.582 56.8883L187.1 141.655L188.698 141.645L188.18 56.8785Z"
          fill="url(#paint6_linear_1_4137)"
        />
        <path
          d="M261.115 61.46L259.62 62.0218L289.431 141.375L290.926 140.813L261.115 61.46Z"
          fill="url(#paint7_linear_1_4137)"
        />
        <path d="M375.289 140.529H-0.841848V147.219H375.313L375.289 140.529Z" fill="url(#paint8_linear_1_4137)" />
        <path
          d="M375.253 147.165H-0.471102L29.4484 176.026H345.764L375.253 147.165Z"
          fill="url(#paint9_radial_1_4137)"
        />
        <path
          d="M327.849 217.919H47.215L28.8563 176.026H345.8L327.849 217.919Z"
          fill="url(#paint10_radial_1_4137)"
        />
        <path
          d="M327.849 217.919H244.696L232.728 176.026H345.8L327.849 217.919Z"
          fill="url(#paint11_radial_1_4137)"
        />
        <path
          d="M47.215 217.919H130.367L142.335 176.026H28.8563L47.215 217.919Z"
          fill="url(#paint12_radial_1_4137)"
        />
        <path
          d="M-0.471102 147.165L28.856 175.942H126.208L154.046 147.105L-0.471102 147.165Z"
          fill="url(#paint13_radial_1_4137)"
        />
        <path
          d="M375.253 147.165L345.926 175.942H248.574L220.737 147.105L375.253 147.165Z"
          fill="url(#paint14_radial_1_4137)"
        />
        <g filter="url(#filter0_d_1_4137)">
          <g filter="url(#filter1_di_1_4137)">
            <path
              d="M334.976 160.485H40.2378C39.7411 160.485 39.3402 160.084 39.3402 159.588C39.3402 159.091 39.7411 158.69 40.2378 158.69H334.976C335.472 158.69 335.873 159.091 335.873 159.588C335.873 160.084 335.472 160.485 334.976 160.485Z"
              fill="#5CDCFF"
            />
          </g>
        </g>
        <path
          d="M77.7571 196.239C77.7571 196.239 88.3546 185.642 91.3107 182.686H283.903C286.859 185.642 294.501 193.283 297.457 196.239H77.7571Z"
          fill="url(#paint15_radial_1_4137)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1_4137"
          x="37.3845"
          y="156.735"
          width="300.444"
          height="5.70651"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.977836" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.905882 0 0 0 0 1 0 0 0 1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_4137" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_4137" result="shape" />
        </filter>
        <filter
          id="filter1_di_1_4137"
          x="38.3623"
          y="158.69"
          width="298.489"
          height="3.75084"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.977836" />
          <feGaussianBlur stdDeviation="0.488918" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_4137" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_4137" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.977836" />
          <feGaussianBlur stdDeviation="0.488918" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_1_4137" />
        </filter>
        <linearGradient
          id="paint0_linear_1_4137"
          x1="187.646"
          y1="140.559"
          x2="187.646"
          y2="44.5231"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#12E7FA" />
          <stop offset="0.09" stopColor="#0BC0F9" />
          <stop offset="0.18" stopColor="#06A2F9" />
          <stop offset="0.22" stopColor="#0597F9" />
          <stop offset="0.32" stopColor="#048BEE" />
          <stop offset="0.49" stopColor="#046DD2" />
          <stop offset="0.72" stopColor="#033DA5" />
          <stop offset="0.92" stopColor="#020D78" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1_4137"
          x1="313.38"
          y1="93.4954"
          x2="386.431"
          y2="93.4954"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1D3CDD" stopOpacity="0" />
          <stop offset="0.22" stopColor="#3379E5" stopOpacity="0.35" />
          <stop offset="0.42" stopColor="#44A9EB" stopOpacity="0.63" />
          <stop offset="0.58" stopColor="#51CCF0" stopOpacity="0.83" />
          <stop offset="0.71" stopColor="#59E1F2" stopOpacity="0.95" />
          <stop offset="0.78" stopColor="#5CEAF4" />
          <stop offset="0.81" stopColor="#67EBF5" />
          <stop offset="0.87" stopColor="#85F1F7" />
          <stop offset="0.95" stopColor="#B6F9FC" />
          <stop offset="1" stopColor="#D4FFFF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1_4137"
          x1="-11.2838"
          y1="93.4951"
          x2="61.7679"
          y2="93.4951"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D4FFFF" />
          <stop offset="0.05" stopColor="#B6F9FC" />
          <stop offset="0.13" stopColor="#85F1F7" />
          <stop offset="0.19" stopColor="#67EBF5" />
          <stop offset="0.22" stopColor="#5CEAF4" />
          <stop offset="0.29" stopColor="#59E1F2" stopOpacity="0.95" />
          <stop offset="0.42" stopColor="#51CCF0" stopOpacity="0.83" />
          <stop offset="0.58" stopColor="#44A9EB" stopOpacity="0.63" />
          <stop offset="0.78" stopColor="#3379E5" stopOpacity="0.35" />
          <stop offset="1" stopColor="#1D3CDD" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1_4137"
          x1="-18.3148"
          y1="53.6485"
          x2="6.62016"
          y2="53.6485"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5CEAF4" />
          <stop offset="0.09" stopColor="#59E1F2" stopOpacity="0.95" />
          <stop offset="0.25" stopColor="#51CCF0" stopOpacity="0.83" />
          <stop offset="0.46" stopColor="#44A9EB" stopOpacity="0.63" />
          <stop offset="0.71" stopColor="#3379E5" stopOpacity="0.35" />
          <stop offset="1" stopColor="#1D3CDD" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1_4137"
          x1="368.533"
          y1="52.5534"
          x2="392.092"
          y2="52.5534"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1D3CDD" stopOpacity="0" />
          <stop offset="0.29" stopColor="#3379E5" stopOpacity="0.35" />
          <stop offset="0.54" stopColor="#44A9EB" stopOpacity="0.63" />
          <stop offset="0.75" stopColor="#51CCF0" stopOpacity="0.83" />
          <stop offset="0.91" stopColor="#59E1F2" stopOpacity="0.95" />
          <stop offset="1" stopColor="#5CEAF4" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1_4137"
          x1="85.3858"
          y1="101.417"
          x2="116.688"
          y2="101.417"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D4FFFF" />
          <stop offset="0.05" stopColor="#B6F9FC" />
          <stop offset="0.13" stopColor="#85F1F7" />
          <stop offset="0.19" stopColor="#67EBF5" />
          <stop offset="0.22" stopColor="#5CEAF4" />
          <stop offset="0.29" stopColor="#59E1F2" stopOpacity="0.95" />
          <stop offset="0.42" stopColor="#51CCF0" stopOpacity="0.83" />
          <stop offset="0.58" stopColor="#44A9EB" stopOpacity="0.63" />
          <stop offset="0.78" stopColor="#3379E5" stopOpacity="0.35" />
          <stop offset="1" stopColor="#1D3CDD" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1_4137"
          x1="173.026"
          y1="104.872"
          x2="202.262"
          y2="93.6893"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D4FFFF" />
          <stop offset="0.05" stopColor="#B6F9FC" />
          <stop offset="0.13" stopColor="#85F1F7" />
          <stop offset="0.19" stopColor="#67EBF5" />
          <stop offset="0.22" stopColor="#5CEAF4" />
          <stop offset="0.29" stopColor="#59E1F2" stopOpacity="0.95" />
          <stop offset="0.42" stopColor="#51CCF0" stopOpacity="0.83" />
          <stop offset="0.58" stopColor="#44A9EB" stopOpacity="0.63" />
          <stop offset="0.78" stopColor="#3379E5" stopOpacity="0.35" />
          <stop offset="1" stopColor="#1D3CDD" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_1_4137"
          x1="259.62"
          y1="101.42"
          x2="290.922"
          y2="101.42"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1D3CDD" stopOpacity="0" />
          <stop offset="0.22" stopColor="#3379E5" stopOpacity="0.35" />
          <stop offset="0.42" stopColor="#44A9EB" stopOpacity="0.63" />
          <stop offset="0.58" stopColor="#51CCF0" stopOpacity="0.83" />
          <stop offset="0.71" stopColor="#59E1F2" stopOpacity="0.95" />
          <stop offset="0.78" stopColor="#5CEAF4" />
          <stop offset="0.81" stopColor="#67EBF5" />
          <stop offset="0.87" stopColor="#85F1F7" />
          <stop offset="0.95" stopColor="#B6F9FC" />
          <stop offset="1" stopColor="#D4FFFF" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_1_4137"
          x1="-0.841848"
          y1="143.874"
          x2="375.313"
          y2="143.874"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0597F9" />
          <stop offset="0.23" stopColor="#12E7FA" />
          <stop offset="0.24" stopColor="#14E7FA" />
          <stop offset="0.3" stopColor="#4DEEFB" />
          <stop offset="0.35" stopColor="#7DF4FC" />
          <stop offset="0.41" stopColor="#A1F8FD" />
          <stop offset="0.46" stopColor="#BCFCFE" />
          <stop offset="0.51" stopColor="#CCFEFE" />
          <stop offset="0.54" stopColor="#D2FFFF" />
          <stop offset="0.58" stopColor="#CDFEFE" />
          <stop offset="0.62" stopColor="#C0FCFE" />
          <stop offset="0.67" stopColor="#ABFAFD" />
          <stop offset="0.71" stopColor="#8DF6FD" />
          <stop offset="0.76" stopColor="#66F1FC" />
          <stop offset="0.8" stopColor="#38EBFB" />
          <stop offset="0.84" stopColor="#12E7FA" />
          <stop offset="0.87" stopColor="#10DEF9" />
          <stop offset="0.92" stopColor="#0DC8F9" />
          <stop offset="0.98" stopColor="#07A4F9" />
          <stop offset="1" stopColor="#0597F9" />
        </linearGradient>
        <radialGradient
          id="paint9_radial_1_4137"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(187.388 147.813) scale(226.88 61.2573)"
        >
          <stop stopColor="#1E429C" />
          <stop offset="1" stopColor="#001038" />
        </radialGradient>
        <radialGradient
          id="paint10_radial_1_4137"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(179.633 184.619) scale(313.419 94.0259)"
        >
          <stop stopColor="#1E429C" />
          <stop offset="1" stopColor="#001038" />
        </radialGradient>
        <radialGradient
          id="paint11_radial_1_4137"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(354.065 201.899) rotate(13.47) scale(33.5219 128.389)"
        >
          <stop stopColor="#9E3CF8" stopOpacity="0.8" />
          <stop offset="0.14" stopColor="#7661F8" stopOpacity="0.6" />
          <stop offset="0.28" stopColor="#5283F8" stopOpacity="0.42" />
          <stop offset="0.43" stopColor="#349FF8" stopOpacity="0.27" />
          <stop offset="0.58" stopColor="#1DB5F8" stopOpacity="0.15" />
          <stop offset="0.72" stopColor="#0DC5F8" stopOpacity="0.07" />
          <stop offset="0.86" stopColor="#03CEF8" stopOpacity="0.02" />
          <stop offset="1" stopColor="#00D2F8" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint12_radial_1_4137"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(32.7413 196.209) rotate(168.84) scale(42.6354 101.046)"
        >
          <stop stopColor="#9E3CF8" />
          <stop offset="0.06" stopColor="#8B4DF8" stopOpacity="0.89" />
          <stop offset="0.21" stopColor="#676FF8" stopOpacity="0.65" />
          <stop offset="0.35" stopColor="#478DF8" stopOpacity="0.45" />
          <stop offset="0.49" stopColor="#2DA6F8" stopOpacity="0.29" />
          <stop offset="0.63" stopColor="#19B9F8" stopOpacity="0.16" />
          <stop offset="0.76" stopColor="#0BC7F8" stopOpacity="0.07" />
          <stop offset="0.89" stopColor="#02CFF8" stopOpacity="0.02" />
          <stop offset="1" stopColor="#00D2F8" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint13_radial_1_4137"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15.513 169.781) rotate(-134.1) scale(182.749 78.582)"
        >
          <stop stopColor="#9E3CF8" stopOpacity="0.8" />
          <stop offset="0.14" stopColor="#7661F8" stopOpacity="0.6" />
          <stop offset="0.28" stopColor="#5283F8" stopOpacity="0.42" />
          <stop offset="0.43" stopColor="#349FF8" stopOpacity="0.27" />
          <stop offset="0.58" stopColor="#1DB5F8" stopOpacity="0.15" />
          <stop offset="0.72" stopColor="#0DC5F8" stopOpacity="0.07" />
          <stop offset="0.86" stopColor="#03CEF8" stopOpacity="0.02" />
          <stop offset="1" stopColor="#00D2F8" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint14_radial_1_4137"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(368.337 170.784) rotate(-45.9) scale(119.732 51.4848)"
        >
          <stop stopColor="#9E3CF8" stopOpacity="0.8" />
          <stop offset="0.14" stopColor="#7661F8" stopOpacity="0.6" />
          <stop offset="0.28" stopColor="#5283F8" stopOpacity="0.42" />
          <stop offset="0.43" stopColor="#349FF8" stopOpacity="0.27" />
          <stop offset="0.58" stopColor="#1DB5F8" stopOpacity="0.15" />
          <stop offset="0.72" stopColor="#0DC5F8" stopOpacity="0.07" />
          <stop offset="0.86" stopColor="#03CEF8" stopOpacity="0.02" />
          <stop offset="1" stopColor="#00D2F8" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint15_radial_1_4137"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(186.961 190.029) scale(145.288 12.3649)"
        >
          <stop stopColor="#1E429C" />
          <stop offset="0.25" stopColor="#173787" />
          <stop offset="0.76" stopColor="#081D53" />
          <stop offset="1" stopColor="#001038" />
        </radialGradient>
      </defs>
    </svg>
  );
}

export default UpgradePlatform;
